import React, { FC } from 'react';
import { Asset, Entry } from "contentful";
import CTA, { CTAProps } from "../CTA";
import { Container, Title, MediaContainer, MainMedia, SecondaryMedia, TertiaryMedia, TextBlock, Subtitle, Description } from './styles';


interface HistoryBlockProps extends Entry {
  brand: string;
  fields: {
    entryTitle?: string;
    layout: string;
    title?: string;
    subtitle?: string;
    description?: string;
    mainMedia?: Asset;
    secondaryMedia?: Asset;
    tertiaryMedia?: Asset;
    cta?: CTAProps;
  };
}

const HistoryBlock: FC<HistoryBlockProps> = ({
  brand,
  fields: {
    title,
    subtitle,
    description,
    mainMedia,
    secondaryMedia,
    tertiaryMedia,
    layout = 'Left',
    cta,
  },
}) => {
  return (
    <Container>
        {title && <Title $layout={layout}>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <MediaContainer>
          {mainMedia && <MainMedia src={`https:${mainMedia.fields.file?.url}`} alt="Main Media" />}
          {secondaryMedia && <SecondaryMedia src={`https:${secondaryMedia.fields.file?.url}`} alt="Secondary Media" $layout={layout} />}
          {tertiaryMedia && <TertiaryMedia src={`https:${tertiaryMedia.fields.file?.url}`} alt="Tertiary Media" $layout={layout} />}
        <TextBlock $layout={layout}>
          {description && <Description>{description}</Description>}
          {cta && (
            <CTA {...cta} brand={brand} />
          )}
        </TextBlock>
        </MediaContainer>
    </Container>
  );
};

export default HistoryBlock;